import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityDetectedApplicationsActiveTokensSlice } from './get';

export const coreDataSecurityDetectedApplicationsActiveTokensReducers = combineReducers({
	get: getCoreDataSecurityDetectedApplicationsActiveTokensSlice.asyncReducers
});

export const coreDataSecurityDetectedApplicationsActiveTokensWatchers = combineAllWatchers([
	getCoreDataSecurityDetectedApplicationsActiveTokensSlice.asyncWatchers
]);
